<template>
  <div>
    <v-select
      :options="options"
      label="value"
      :disabled="
        tmp_praxis &&
        value &&
        tmp_praxis.value === value.value
      "
      v-model="tmp_praxis"
      :class="{'hide-search': tmp_praxis}"
      :placeholder="$t('praxis_placeholder')"
      :clearable="false"
      :searchable="false"
    >
      <template slot="option" slot-scope="option">
        {{ option.title }}
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option.title }}
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes" class="text"
          ><font-awesome-icon icon="sort-down"
        /></span>
      </template>
    </v-select>
    <!--<button
      v-if="
        !(
          tmp_praxis &&
          value &&
          tmp_praxis.value === value.value
        )
      "
      @click="handleInput"
      class="btn btn-primary mt-3 d-block"
      :disabled="!tmp_praxis"
    >
      {{ $t("actions.auswahl_uebernehmen") }}
    </button>-->
  </div>
</template>

<script>
export default {
  name: "PraxisSelect",
  props: {
    options: { required: true },
    value: { type: Object, default: null },
  },
  data() {
    return {
      tmp_praxis: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function(v) {
        this.tmp_praxis = v;
      }
    },
    tmp_praxis: {
      immediate: true,
      handler: function(v) {
        this.tmp_praxis = v;
        this.$emit("input", this.tmp_praxis);
      }
    }
  },
  /*methods: {
    handleInput() {
      this.$emit("input", this.tmp_praxis);
    },
  },*/
};
</script>
